module.exports = __webpack_public_path__ + "img/bg_page_load.11a2177e.jpg";